import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEsCO from '@angular/common/locales/es-CO';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideNgxMask } from 'ngx-mask';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { membershipInterceptor } from './shared/interceptors/membership.interceptor';
import { API_BASE_URL } from './shared/api/api.tokens';
import { environment } from '../environments/environment';
import { STATUS_DEF_MAP } from './shared/api/eventStatus.token';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([AuthInterceptor, membershipInterceptor])),
    provideNgxMask(),
    { provide: API_BASE_URL, useValue: environment.apiUrl },
    {
      provide: STATUS_DEF_MAP,
      useValue: {
        scheduled: {
          eventStatusId: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
          name: 'Agendado',
          color: '#3B82F6',
        },
        confirmed: {
          eventStatusId: 'b2c3d4e5-f6a7-8901-bcde-f23456789012',
          name: 'Confirmado',
          color: '#10B981',
        },
        completed: {
          eventStatusId: 'c3d4e5f6-a7b8-9012-cdef-345678901234',
          name: 'Completado',
          color: '#6366F1',
        },
        cancelled: {
          eventStatusId: 'd4e5f6a7-b8c9-0123-defa-456789012345',
          name: 'Cancelado',
          color: '#EF4444',
        },
        hidden: {
          eventStatusId: 'e5f6a7b8-c9d0-1234-efab-567890123456',
          name: 'Oculto',
          color: '#9CA3AF',
        },
      } as const,
    },
    { provide: LOCALE_ID, useValue: 'es-CO' },
  ],
};
